module.exports = __webpack_public_path__ + "img/startConfigurationAttachmentSetting.a5553a0.png";